// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uv0WDy{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;margin:10px 10px 6px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `uv0WDy`
};
export default ___CSS_LOADER_EXPORT___;
